var map = {
	"./about/About.vue": [
		623,
		20
	],
	"./archive/Archive.vue": [
		624,
		23
	],
	"./archiveWinners/ArchiveWinners.vue": [
		625,
		22
	],
	"./docs/Docs.vue": [
		626,
		35
	],
	"./home/Home.vue": [
		627,
		8
	],
	"./kontur/Kontur.vue": [
		628,
		27
	],
	"./live/Live.vue": [
		629,
		18
	],
	"./members/Members.vue": [
		630,
		14
	],
	"./news/News.vue": [
		631,
		2
	],
	"./notFound/NotFound.vue": [
		632,
		34
	],
	"./partners/Partners.vue": [
		633,
		31
	],
	"./votes/Votes.vue": [
		634,
		6
	],
	"./votesForm/VotesForm.vue": [
		635,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 596;


//////////////////
// WEBPACK FOOTER
// ./src/app2026/pages lazy ^\.\/.*\.vue$
// module id = 596
// module chunks = 41